import { i as b } from "../separate-component-helper-chunks/reactive-element-BDpydG15.js";
import { html as u } from "../beacon-html.d/index.js";
import "../separate-component-helper-chunks/lit-element-DC8UPTKS.js";
import { property as t } from "../beacon-property.d/index.js";
import { live as h } from "../beacon-live.d/index.js";
import { B as f } from "../separate-component-helper-chunks/form-base-6uTDnSZ3.js";
import { B as p } from "../separate-component-helper-chunks/beacon-primitive-ChVMWFlW.js";
import { a as m } from "../separate-component-helper-chunks/query-assigned-DZ4JAxBy.js";
const v = b`label,.label{font-size:var(--beacon-form-label-font-size);font-weight:var(--beacon-form-label-font-weight);line-height:var(--beacon-form-label-font-line-height);margin:0;padding:0}.hint{font-size:var(--beacon-form-font-size);line-height:var(--beacon-form-font-line-height);margin:0}input,select,textarea{color:var(--beacon-form-field-color-text-default)}[aria-disabled=true]{caret-color:transparent;color:var(--beacon-form-field-color-text-inactive);cursor:not-allowed}:host{align-items:center;display:inline-flex;gap:calc(.75 * var(--beacon-unit-base))}input.beacon-radio-button{--radio-size: calc(1.75 * var(--beacon-unit-base));--radio-size-outer: calc(1.125 * var(--beacon-unit-base));--radio-cursor: pointer;--radio-background-color: var(--beacon-form-label-color-cta-default);--radio-border-color: var(--beacon-color-border-primary-default);-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--beacon-form-field-color-background);block-size:var(--radio-size);cursor:var(--radio-cursor);display:grid;margin:0;min-inline-size:var(--radio-size);place-items:center;border-color:var(--radio-border-color);border-radius:var(--beacon-radii-circle);border-style:solid;border-width:var(--beacon-border-width-small)}input.beacon-radio-button:before{background:var(--radio-background-color);block-size:var(--radio-size-outer);border-radius:var(--beacon-radii-circle);content:"";inline-size:var(--radio-size-outer);transform:scale(0)}input.beacon-radio-button+label.beacon-radio-button-label{--label-weight: var(--beacon-font-weight-normal);--label-cursor: pointer;align-items:center;cursor:var(--label-cursor);display:inline-flex;font-size:var(--beacon-form-font-size);font-weight:var(--label-weight);gap:calc(.75 * var(--beacon-unit-base));line-height:var(--beacon-form-font-line-height)}input.beacon-radio-button:checked{--radio-border-color: var(--beacon-form-label-color-cta-default)}input.beacon-radio-button:checked:before{transform:scale(1)}input.beacon-radio-button:checked+label.beacon-radio-button-label{--label-weight: var(--beacon-font-weight-bold)}input.beacon-radio-button[aria-disabled=true]{--radio-cursor: not-allowed;--radio-border-color: var(--beacon-color-border-primary-inactive)}input.beacon-radio-button[aria-disabled=true]:checked{--radio-background-color: var(--beacon-color-cta-secondary-inactive);--radio-border-color: var(--beacon-color-border-primary-inactive)}input.beacon-radio-button[aria-disabled=true]+label.beacon-radio-button-label{--label-cursor: not-allowed;color:var(--beacon-color-text-inactive)}input.beacon-radio-button.error{--radio-border-color: var(--beacon-form-field-color-border-error)}`;
var g = Object.defineProperty, r = (c, e, l, k) => {
  for (var a = void 0, i = c.length - 1, d; i >= 0; i--)
    (d = c[i]) && (a = d(e, l, a) || a);
  return a && g(e, l, a), a;
};
const s = "beacon-radio-button", n = class n extends p(f) {
  constructor() {
    super(...arguments), this.beaconTagName = s, this.name = "", this.checked = !1, this.focusable = !1, this.handleChange = (e) => {
      this.disabled ? e.preventDefault() : (this.checked = !0, super.handleChange(e));
    }, this.handleRadioInput = (e) => {
      this.disabled ? e.preventDefault() : this.checked = !0, super.emitInput(e);
    }, this.handleRadioClick = (e) => {
      this.disabled ? e.preventDefault() : this.checked = !0, super.emitClick(e);
    }, this.focusShadow = () => {
      this.radioButton.focus();
    };
  }
  static get styles() {
    return [super.styles, v];
  }
  render() {
    return u` <input
        type="radio"
        id="${this.id}"
        class="beacon-radio-button ${this.invalid ? "error" : ""} form-anchor"
        .value="${this.value}"
        aria-invalid=${this.invalid}
        aria-disabled=${this.disabled}
        aria-checked=${this.checked}
        @blur=${this.emitBlur}
        @input="${this.handleRadioInput}"
        @focus="${this.emitFocus}"
        @click="${this.handleRadioClick}"
        @change="${this.handleChange}"
        .checked=${h(this.checked)}
        name="${this.name}"
        tabindex="${this.checked || this.focusable ? "0" : "-1"}"
      />
      <label for="${this.id}" class="beacon-radio-button-label">${this.label}</label>`;
  }
};
n.tagName = s;
let o = n;
r([
  m("input")
], o.prototype, "radioButton");
r([
  t({ reflect: !0 })
], o.prototype, "name");
r([
  t({ type: Boolean, reflect: !0 })
], o.prototype, "checked");
r([
  t({ type: Boolean })
], o.prototype, "focusable");
export {
  o as BeaconRadioButton
};
